import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import * as Loadings from '../../../../../constants/loadings/facilita/deathDeclaration';
import featuresOverview from '../../../../../assets/images/placeholder/Features-Overview.svg';
import {updateOnboardingStep}  from '../../../../../actions/facilita-api';

export const BilledByPartner = ({userId, isLoading}) => {
    const dispatch = useDispatch();
    const history = useHistory();

    return (
        <article className="view-calc mb-auto pt-3">
                <div className="auto-view my-auto">
                    <div className="container-fluid">
                        <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 mb-gutter text-center">
                            <img className="img-fluid mx-auto container-md-press mb-gutter" src={featuresOverview} alt="features overview" />
                            <div className="container-default mx-auto">
                                <h1 className="text-primary font-weight-bolder mt-0 mb-1">Résumé</h1>
                                <p className="h3 mb-0">Résumé du dossier du défunt.</p>
                            </div>
                        </header>
                        <section className="block container-default mx-auto">
                            <h4 className="fs-3 text-uppercase font-weight-bolder mt-0">Votre tarif comprend :</h4>
                            {/* <h3 className="h3 font-weight-bolder mt-3 mb-2">Votre tarif comprend :</h3> */}
                            <div className="card border-0">
                                <div className="card-body">
                                    <div role="button" className="d-flex align-items-start small">
                                        <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                        <span className="o-80">Création d'un dossier personnalisé</span>
                                    </div>
                                    <div role="button" className="d-flex align-items-start small mt-2">
                                        <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                        <span className="o-80">Création, copie et adressage</span>
                                    </div>
                                    <div role="button" className="d-flex align-items-start small mt-2">
                                        <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                        <span className="o-80">Un espace bibliothèque pour déposer des documents accessibles à tous les proches invités</span>
                                    </div>
                                    <div role="button" className="d-flex align-items-start small mt-2">
                                        <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                        <span className="o-80">Un accès à la plateforme pendant 1 an après le décès</span>
                                    </div>                                    
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <footer className="block mt-auto mb-sm text-right w-100">
                    <div className="container-fluid flex-row align-items-center">
                        <Link to={`/facilita/${userId}/onboarding/step3`} className="btn btn-faded px-md-gutter mr-3 ml-auto">Retour</Link>
                        {
                            isLoading.includes(Loadings.UPDATING_USER_ONBOARDINGSTEP) ?
                                <button className="btn btn-info px-md-gutter px-4 loading-btn show" disabled={true}>Terminer<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
                            :
                                <button className="btn btn-info px-md-gutter px-4 loading-btn" onClick={() => { 
                                    dispatch(updateOnboardingStep(userId, 6))
                                    .then(() => {
                                        history.push(`/facilita/${userId}`)
                                    })
                                
                                }}>Terminer<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
                        }
                        
                    </div>
                </footer>
            </article>
    )
}